<template>
    <div class="template">
        <div class="template-body" v-if="videoList">
            <div class="template-group">
                <div class="panel-row">
                    <p class="panel-row-label">
                        <span>标题</span>
                    </p>
                    <Input v-model="videoList[0].title" :placeholder="`必填，限制25个字符`" :maxlength="100" />
                </div>
                <!-- 描述 -->
                <div class="panel-row">
                    <p class="panel-row-label">
                        <span>描述</span>
                    </p>
                    <Input
                        v-model="videoList[0].description"
                        :rows="3"
                        :placeholder="`必填，建议输入90个字符以内的内容`"
                        :maxlength="200"
                        type="textarea"
                    />
                </div>
                <!-- 图片上传 -->
                <div class="panel-row">
                    <p class="panel-row-label">
                        <span>图片上传</span>
                        <!-- <span v-if="!imgList.length && blur.imgUrl" class="panel-row-error">
                            <Icon class="panel-row-error-icon" type="close-circled"></Icon>请上传至少一张图片
                        </span> -->
                    </p>
                    <div class="banner-img-list">
                        <!-- 上传框 -->
                        <div class="banner-img-item">
                            <!-- 影子元素 -->
                            <input
                                ref="imgUrl"
                                :multiple="false"
                                type="file"
                                hidden
                                accept="image/jpeg,image/jpg,image/png"
                                @change="onImgFileChange($event)"
                            />
                            <!-- 上传中动画 -->
                            <cSpin v-if="loading" :size="0.1" :radius="0.05" color="#23c52f" background="#fafafa" />
                            <div class="item-upload" @click="$refs.imgUrl.click()">
                                <Icon class="item-upload-icon" type="plus-round"></Icon>
                                <span class="item-upload-text">上传</span>
                            </div>
                        </div>

                        <!-- 缩略图框 -->
                        <div class="banner-img-item" v-if="videoList[0].imgUrl">
                            <div class="item-img-box" @mouseover="imgPreview = true" @mouseout="imgPreview = false">
                                <img :src="videoList[0].imgUrl" class="item-img" />
                                <transition name="fade">
                                    <div v-show="imgPreview" class="img-function">
                                        <span
                                            class="function-icon"
                                            @click="
                                                previewImg(
                                                    'img',
                                                    videoList[0].imgUrl,
                                                    imgSizeList[videoList[0].sizeType]
                                                )
                                            "
                                            ><Icon type="eye"></Icon
                                        ></span>
                                        <span class="function-icon" @click="remove('img')"
                                            ><Icon type="android-delete"></Icon
                                        ></span>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                    <p class="panel-row-label no-margin">建议尺寸：720*1280</p>
                </div>
                <!-- 视频上传 -->
                <div class="panel-row">
                    <p class="panel-row-label">
                        <span>视频上传</span>
                    </p>
                    <div class="banner-img-list">
                        <!-- 上传框 -->
                        <div class="banner-img-item">
                            <!-- 影子元素 -->
                            <input
                                ref="videoUrl"
                                :multiple="false"
                                type="file"
                                hidden
                                accept="video/mp4"
                                @change="onVideoFileChange($event)"
                            />
                            <!-- 上传中动画 -->
                            <cSpin
                                v-if="videoLoading"
                                :size="0.1"
                                :radius="0.05"
                                color="#23c52f"
                                background="#fafafa"
                            />
                            <div class="item-upload" @click="$refs.videoUrl.click()">
                                <Icon class="item-upload-icon" type="plus-round"></Icon>
                                <span class="item-upload-text">上传</span>
                            </div>
                        </div>
                        <!-- 缩略图框 -->
                        <div class="banner-img-item" v-if="videoList[0].videoUrl">
                            <div class="item-img-box" @mouseover="videoPreview = true" @mouseout="videoPreview = false">
                                <video :src="videoList[0].videoUrl" width="100" height="100"></video>
                                <transition name="fade">
                                    <div v-show="videoPreview" class="img-function">
                                        <span
                                            class="function-icon"
                                            @click="
                                                previewImg(
                                                    'video',
                                                    videoList[0].videoUrl,
                                                    imgSizeList[videoList[0].sizeType]
                                                )
                                            "
                                            ><Icon type="eye"></Icon
                                        ></span>
                                        <span class="function-icon" @click="remove('video')"
                                            ><Icon type="android-delete"></Icon
                                        ></span>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                    <p class="panel-row-label no-margin">
                        建议视频大小15m以下，不超过30m{{ uploadVideoRes && uploadVideoRes.videoSize }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mixins from '@/mixins/index';
import cSpin from '@/components/commons/cSpin.vue';
export default {
    components: { cSpin },
    mixins: [mixins],
    props: {
        blur: {
            type: Object,
        },
    },
    data() {
        return {
            imgPreview: false,
            videoPreview: false,
            loading: false,
            videoLoading: false,
            sizeList: [
                { title: 'Banner', size: '320x50', sizeType: 5, type: 'Banner', selected: true },
                { title: 'Mrec', size: '300x250', sizeType: 1, type: 'Mrec', selected: true },
                { title: 'Interstitial', size: '320x480', sizeType: 6, type: 'Interstitial', selected: true },
                { title: 'Native_1', size: '1200x627', sizeType: 7, type: 'Native', selected: true },
                { title: 'Native_2', size: '320x200', sizeType: 8, type: 'Native', selected: true },
            ],
            description: '',
            uploadVideoRes: {}, //上传视频结果
        };
    },
    computed: {
        infoParams() {
            return this.$store.state.newPromotion.infoParams;
        },
        status() {
            return this.$store.state.newPromotion.status;
        },
        imgList() {
            return this.$store.state.newPromotion.imgList;
        },
        videoList() {
            return this.$store.state.newPromotion.videoList;
        },
        imgSizeList() {
            return this.$store.state.newPromotion.imgSizeList;
        },
        //错误验证
        infoError() {
            const { sizeList, infoParams } = this;
            return {
                size: sizeList.every((item) => !item.selected),
                textList: infoParams.textList.map((item) => ({
                    name: !item.name || item.name.length > 35,
                    title: !item.title || item.title.length > 50,
                    description:
                        (!item.description || item.description.length > 200) &&
                        sizeList.some((item) => item.sizeType != 5 && item.selected),
                    buttonText: !item.buttonText || item.buttonText.length > 11,
                })),
                imgUrl:
                    sizeList.some((item) => item.sizeType != 8 && item.sizeType != 5 && item.selected) &&
                    !infoParams.imgList.length,
                nativeImgUrl:
                    this.status == 'add' &&
                    sizeList.some((item) => item.sizeType == 8 && item.selected) &&
                    !infoParams.nativeImgList.length,
                iconUrl: !infoParams.iconUrl,
            };
        },
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        /**
         * @desc 弹窗预览图片
         * @param {String} type 类型
         * @param {String} url 预览的图片地址
         * @param {String} size 宽x高
         */
        previewImg(type, url, size) {
            // const maxWidth = 720;
            // const minWidth = 418;
            // const width = ~~size.split('x')[0];
            // let modalWidth = width + 40 > minWidth ? width + 40 : minWidth;
            // modalWidth = modalWidth > maxWidth + 40 ? maxWidth + 40 : modalWidth;
            this.$Modal.info({
                render: (h) =>
                    type === 'img'
                        ? h('img', {
                              attrs: { src: url },
                              style: { width: '100%' },
                              // style: { width: `${width > maxWidth ? maxWidth : width}px`, margin: '0 auto' },
                          })
                        : h(
                              'video',
                              {
                                  attrs: { controls: true },
                                  style: { width: '100%' },
                              },
                              [
                                  h('source', {
                                      attrs: { src: url },
                                      style: { width: '100%' },
                                  }),
                              ]
                          ),
                // width: modalWidth,
                okText: '关闭',
            });
        },
        /**
         * @desc 移除图片
         */
        remove(type) {
            if (type === 'img') {
                this.$store.commit('videoList', [{ ...this.videoList[0], imgUrl: '' }]);
            } else if (type === 'video') {
                this.$store.commit('videoList', [{ ...this.videoList[0], videoUrl: '' }]);
            } else {
                console.error('移除图片错误');
            }
        },
        /**
         * 判断文件类型是否正确，正确则返回true，否则返回false
         * @file 文件
         * @type 文件类型，如：mp4
         */
        judgeFileType(file, type) {
            let filename = file.name.split('.');
            filename = filename[filename.length - 1];
            if (filename === type) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @desc 上传图片
         * @param {Event} e: 原生input事件
         */
        async onImgFileChange(e) {
            if (this.videoList[0].imgUrl !== '') {
                this.$Message.error({ content: '只能上传一个图片', duration: 2 });
                //清空input
                e.target.value = '';
                return;
            }
            const files = Array.from(e.target.files);

            //没有选择图片则返回
            if (!files.length) return;

            this.loading = true;

            const formData = new FormData();
            files.forEach((file) => formData.append('img', file));
            try {
                const res = await this.$axios.post(this.$port.manager.uploadImg, formData, { cancelLoading: true });
                if (res.status !== 200) {
                    this.videoLoading = false;
                    //清空input
                    e.target.value = '';
                    this.$Message.error({ content: res.message, duration: 2 });
                    return;
                }
                //数据处理
                this.loading = false;
                const result = [{ ...this.videoList[0], imgUrl: res.data.urls[0] }];
                this.$store.commit('videoList', result);
                //清空input
                e.target.value = '';
                this.blur.imgUrl = true;
            } catch (error) {
                console.log('上传图片出错');
            }
        },

        /**
         * @desc 上传视频
         * @param {Event} e: 原生input事件
         */
        async onVideoFileChange(e) {
            if (this.videoList[0].videoUrl !== '') {
                this.$Message.error({ content: '只能上传一个视频', duration: 2 });
                return;
            }
            let files = Array.from(e.target.files);
            // 类型限制mp4
            if (files.some((file) => !this.judgeFileType(file, 'mp4'))) {
                this.$Message.error({ content: '视频格式要求是mp4格式', duration: 2 });
                //清空input
                e.target.value = '';
                return;
            }
            //没有选择图片则返回
            if (!files.length) return;

            this.videoLoading = true;
            const formData = new FormData();
            files.forEach((file) => formData.append('video', file));
            try {
                const uploadVideoRes = await this.$axios.post(this.$port.manager.uploadVideo, formData, {
                    cancelLoading: true,
                });
                if (uploadVideoRes.status !== 200) {
                    this.videoLoading = false;
                    //清空input
                    e.target.value = '';
                    this.$Message.error({ content: uploadVideoRes.message, duration: 2 });
                    return;
                }
                this.uploadVideoRes = uploadVideoRes.data;
                //数据处理
                this.videoLoading = false;
                const result = [
                    {
                        ...this.videoList[0],
                        videoUrl: uploadVideoRes.data.videoUrl,
                        videoTime: uploadVideoRes.data.videoTime,
                        videoSize: uploadVideoRes.data.videoSize,
                        name: files[0].name.split('.')[0],
                        sizeType: 3,
                        showFunction: false,
                        status: 1,
                        creativeType: 3,
                    },
                ];
                this.$store.commit('videoList', result);
                //清空input
                e.target.value = '';
                this.blur.imgUrl = true;
            } catch (error) {
                console.log('上传视频出错');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/NewPromotion/Creative/Video.vue